module.exports = __webpack_public_path__ + "img/Weapon_217.c7ee2408.png";